const margin = 8;
const topbarHeight = 100;
const breadCrumbHeight = 0;
const appDrawerWidth = 320;
const appDrawerCollapsedWidth = 80;
const appDrawerItemHeight = 30;
const pageDrawerWidth = 230;
const pageDrawerWidthSmall = 150;
const minimumPageWidth = 800;
const minimumPageHeight = 1200;
const homeGridHeight = 400;
const pageMargin = 30;
const baseWidth = 1440;
const baseHeight = 900;
const homeGridWidth = 320;

export const dimensions = {
  topbarHeight: topbarHeight,
  breadCrumbHeight: breadCrumbHeight,
  totalTopbarHeight: breadCrumbHeight + 4 * margin + topbarHeight,
  pageDrawerWidth: pageDrawerWidth,
  pageDrawerWidthSmall: pageDrawerWidthSmall,
  appDrawerWidth: appDrawerWidth,
  appDrawerCollapsedWidth: appDrawerCollapsedWidth,
  totalAppDrawerWithPageDrawer: appDrawerWidth + pageDrawerWidth + margin * 3,
  totalAppDrawerCollapsedWidthWithPageDrawer:
    appDrawerCollapsedWidth + pageDrawerWidth + margin * 3,
  appDrawerItemHeight: appDrawerItemHeight,
  margin: margin,
  heightAppBar: topbarHeight,
  minimumPageWidth: minimumPageWidth,
  minimumPageHeight: minimumPageHeight,
  homeGridHeight: homeGridHeight,
  pageMargin: pageMargin,
  baseHeight: baseHeight,
  baseWidth: baseWidth,
  homeGridWidth: homeGridWidth,
};

export const getDimensions = () => dimensions;
